export default {
  google: "fonts.google.com",
  custom: "custom",
  system: "system",
}